import React from "react";
import { ThreeRow } from "../../core/layouts";
import { useIntl } from "react-intl";
import { Text, Tag } from "react_reusable_components";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import variables from "../../themes/base/styles/variables";

const ProductAndSubProductViewOnlyContainerStyle = {
  headingStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  },
  topSectionStyle: {
    marginTop: variables.marginMedium,
  },
  bottomSectionProductWrapperStyle: {
    padding: variables.paddingMedium,
    border: `1px solid ${variables.grey4}`,
    width: variables.fullWidth,
    marginTop: variables.marginMediumSmall,
  },
  tagStyle: {
    borderRadius: variables.radiusLg2,
    lineHeight: variables.lineHeightNormal,
    fontWeight: variables.fontWeightNormal,
    color: variables.textDefault,
    padding: `${variables.paddingXSmall} ${variables.paddingSmall}`,
    height: "2rem",
    alignItems: variables.alignCenter,
    justifyContent: variables.spaceBetween,
    background: variables.lightCraftingBlue,
    border: variables.tagBorder,
    fontSize: variables.fontSizeSmall,
    marginBottom: variables.marginSmallest,
    marginRight: variables.marginSmall,
  },
  productHeadingStyle: {
    lineHeight: variables.lineHeightNormal,
    fontSize: variables.fontSizeNormal,
    color: variables.textDefault,
  },
  bottomSectionContainerStyle: {
    width: variables.fullWidth,
  },
  productChipsWrapperStyle: {
    marginTop: variables.marginMediumSmall,
  },
  subProductsWrapperStyle: {
    display: variables.dFlex,
    flexWrap: variables.flexWrap,
    gap: variables.gapXS,
  },
  roleNameStyle: {
    color: variables.textDefault,
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    lineHeight: variables.lineHeightSmall,
  },
  categoryWrapperStyle: {
    border: `1px solid ${variables.grey4}`,
    padding: variables.paddingMedium,
  },
  middleSectionStyle: {
    marginTop: variables.marginMedium,
  },
};

export default function ProductAndSubProductViewOnlyContainer({
  productSubProductsOptions,
  roleName,
  style,
}) {
  const intl = useIntl();

  return (
    <ThreeRow
      style={{
        ...ProductAndSubProductViewOnlyContainerStyle.categoryWrapperStyle,
        ...style,
      }}
      topSection={
        <Text style={ProductAndSubProductViewOnlyContainerStyle.roleNameStyle}>
          {roleName}
        </Text>
      }
      middleSectionStyle={
        ProductAndSubProductViewOnlyContainerStyle.middleSectionStyle
      }
      middleSection={
        <Text style={ProductAndSubProductViewOnlyContainerStyle.headingStyle}>
          {getLocalizedMessage(
            intl,
            "addUser.text.categoryProductAndSubProduct"
          )}
        </Text>
      }
      bottomSection={
        <div
          style={
            ProductAndSubProductViewOnlyContainerStyle.bottomSectionContainerStyle
          }
        >
          {productSubProductsOptions?.map((product, index) => (
            <div key={product?.id}>
              <div
                style={
                  ProductAndSubProductViewOnlyContainerStyle.bottomSectionProductWrapperStyle
                }
              >
                <Text
                  style={
                    ProductAndSubProductViewOnlyContainerStyle.productHeadingStyle
                  }
                >
                  {product?.productCategoryName}
                </Text>

                <div
                  style={
                    ProductAndSubProductViewOnlyContainerStyle.productChipsWrapperStyle
                  }
                >
                  {product?.subCategory.map((subproduct) => (
                    <Tag
                      color={variables.lightCraftingBlue}
                      style={
                        ProductAndSubProductViewOnlyContainerStyle.tagStyle
                      }
                    >
                      {subproduct?.name}
                    </Tag>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    />
  );
}
